import { cx } from 'lib/cx'
import { QuotesIcon } from './icons/Quotes'
import { Overline } from './Overline'
import { Paragraph } from './Paragraph'

export const Quote = ({
  quote,
  author,
  children,
  className,
}: {
  quote?: React.ReactNode
  author?: React.ReactNode
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <article className={cx('flex gap-16 flex-col md:flex-row', className)}>
      <span className="text-highlight w-64">
        <QuotesIcon />
      </span>
      <blockquote className="grid gap-16 content-start">
        {quote && <Paragraph>{quote}</Paragraph>}
        {author && <Overline>{author}</Overline>}
        {children}
      </blockquote>
    </article>
  )
}
